import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Carousel } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Footer from './Footer.js'

const captions = [
    "Goal[sic], in Walnut Street",
    "High Street, From the Country Marketplace",
    "Bank of Pennsylvania",
    "The House Intended for the President of the United States, in Ninth Street",
    "Second Street North from Market St. with Christ Church",
    "Mendenhall Ferry, Schuylkill, Pennsylvania",
    "Back of the State House"
];

const Home = () => {
    const [headerSrc, setHeaderSrc] = useState(`${process.env.PUBLIC_URL}/images/home/header.jpg`);

    useEffect(() => {
        const updateImage = () => {
            setHeaderSrc(
                window.innerWidth <= 767
                    ? `${process.env.PUBLIC_URL}/images/home/header-sm.jpg`
                    : `${process.env.PUBLIC_URL}/images/home/header.jpg`
            );
        };

        updateImage();
        window.addEventListener('resize', updateImage);
        return () => window.removeEventListener('resize', updateImage);
    }, []);

    return (
        <div className="container">
            <div className="home-header-image">
                <img
                    src={headerSrc}
                    alt="Charles Brockden Brown Archive Header"
                    className="img-fluid"
                    style={{ width: "100%", height: "auto" }}
                />
            </div>

            <div className="row margin-change-row">
                <div className="col-md-8 col-sm-12 about-author">
                    <h5 style={{ paddingTop: '20px' }}>About the Author</h5>
                    <p>
                        Charles Brockden Brown (1771-1810) has earned a general reputation as the early republic's
                        most ambitious and accomplished literary figure. He wrote prolifically in many genres,
                        founded and edited three major magazines, published widely-read political pamphlets, and
                        intervened in many debates about the culture and politics of the new nation. Brown is mostly
                        known for his novels and for <em>Alcuin</em>, his dialogue on women's rights.
                    </p>
                    <Link to="/biography" className="btn btn-default">Read more</Link>
                </div>
            </div>

            <div className="row home-page">
                <div className="col-lg-6" style={{ paddingLeft: 0, paddingTop: 10 }}>
                    <Carousel fade>
                        {captions.map((caption, index) => (
                            <Carousel.Item key={index}>
                                <img
                                    className="d-block w-100"
                                    src={`${process.env.PUBLIC_URL}/images/home/${index + 1}.jpg`}
                                    alt={caption}
                                />
                                <Carousel.Caption>
                                    <h3>{caption}</h3>
                                </Carousel.Caption>
                            </Carousel.Item>
                        ))}
                    </Carousel>
                    <h6>
                        Landscape engravings of Philadelphia by{' '}
                        <a href="http://www.ushistory.org/birch/intro.htm">
                            William Russell Birch (1755-1834)
                        </a>
                    </h6>
                </div>

                <div className="col-lg-3 col-lg-offset-2" style={{ paddingLeft: 0, paddingTop: 10 }}>
                    <a href={`${process.env.PUBLIC_URL}/images/home/1798-L-108.jpg`} target="_blank" rel="noopener noreferrer">
                        <img src={`${process.env.PUBLIC_URL}/images/home/home3.jpg`} alt="Letter to Thomas Jefferson" />
                    </a>
                    <h6>Letter to Thomas Jefferson, December 25, 1798 (Library of Congress)</h6>
                </div>
            </div>

            <div className="row home-page">
                <div className="col-md-8">
                    <h3>Support the Project</h3>
                    <p>
                        To support The Charles Brockden Brown Electronic Archive and Scholarly Edition, you can make a
                        tax-deductible contribution through online donations, planned giving, corporate matching, and more.
                    </p>
                    <Link to="/support" className="btn btn-default">Find out more</Link>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Home;
